// 本文件是自动生成, 请勿修改
import a_webmgr from '@/plugins/a_webmgr/stage-config'
import b_showcase from '@/plugins/b_showcase/stage-config'
import c_article from '@/plugins/c_article/stage-config'
import d_project from '@/plugins/d_project/stage-config'

const pluginsConfig = [
  a_webmgr,
  b_showcase,
  c_article,
  d_project,
]

export default pluginsConfig
